@if (isActive()) {
  <div
    cdkOverlay
    class="cdk-overlay-backdrop cdk-overlay-dark-backdrop cdk-overlay-backdrop-showing"
    (click)="closeModule()"
    [@fadeInOut]
  ></div>
  <div
    class="navigation-m"
    [@slideInOut]
    role="dialog"
    aria-modal="true"
    tabindex="-1"
  >
    <div #navigationContent class="navigation-content" cdkScrollable>
      <div class="navigation-top">
        @if (headerUrl()) {
          <boels-generic-link
            [url]="headerUrl()"
            class="navigation-top-title-link"
          >
            @if (navigatedLevel() && headerTitle()) {
              <h4 class="navigation-top-title">
                {{ headerTitle() }}
              </h4>
            }
          </boels-generic-link>
        } @else if (navigatedLevel() && headerTitle()) {
          <h4 class="navigation-top-title">
            {{
              navigatedLevel() > 1
                ? headerTitle()
                : navigationData()?.assortmentSubtitle
            }}
          </h4>
        }

        <div class="navigation-top-buttonBox">
          @if (navigatedLevel()) {
            <fa-icon
              [icon]="faArrowLeft"
              class="navigation-top-close-back"
              (click)="navigateBack()"
            ></fa-icon>
          }
          <button
            #closeButton
            class="navigation-top-close-button"
            [attr.aria-label]="'common.close' | transloco"
            (click)="closeModule()"
          >
            <img
              class="navigation-top-icon"
              alt=""
              src="assets/images/misc/close.svg"
            />
          </button>
        </div>
      </div>
      @for (nav of activeNode(); track nav) {
        @if ({ resolvedData: nav.resolvedData | async }; as tempObject) {
          <nav
            class="navigation-item"
            (click)="navigateCategory(nav, tempObject.resolvedData)"
            [attr.aria-haspopup]="
              getHasChildrenCategory(nav, tempObject.resolvedData)
            "
            role="menuitem"
          >
            @if (!nav.pages && tempObject.resolvedData) {
              <ng-container
                [ngTemplateOutlet]="navigation_row"
                [ngTemplateOutletContext]="{
                  nav_data: getNavObject(
                    getCmsNavigationNodeCategory(nav, tempObject.resolvedData),
                    getHasChildrenCategory(nav, tempObject.resolvedData),
                    getCmsNavigationNodeUrl(nav, tempObject.resolvedData)
                  ),
                }"
              ></ng-container>
            }
            @if (nav.pages || !tempObject.resolvedData) {
              <ng-container
                [ngTemplateOutlet]="navigation_row"
                [ngTemplateOutletContext]="{
                  nav_data: getNavObject(
                    nav?.title || nav?.name,
                    !!(nav?.children?.length || nav?.pages?.pages?.length),
                    nav?.url
                  ),
                }"
              ></ng-container>
            }
          </nav>
        }
      }
    </div>
    @if (!userLoggedIn()) {
      <div class="navigation-toggle-context">
        @if (!userLoggedIn() && showUserType()) {
          <div class="toggle-section">
            <boels-toggle-user-type></boels-toggle-user-type>
          </div>
        }
        @if (showCountrySelect()) {
          <div class="toggle-section">
            <boels-toggle-language-selector
              [inMobileMenu]="true"
              (languageSelected)="closeModule()"
            ></boels-toggle-language-selector>
          </div>
        }
      </div>
    }
  </div>
}

<ng-template #navigation_row let-nav="nav_data">
  @if (!nav.hasChildren) {
    <boels-generic-link (click)="navigateToPage(nav.url)">
      <ng-container
        [ngTemplateOutlet]="navigation_row_item"
        [ngTemplateOutletContext]="{
          nav_data: nav,
        }"
      ></ng-container>
    </boels-generic-link>
  }
  @if (nav.hasChildren) {
    <ng-container
      [ngTemplateOutlet]="navigation_row_item"
      [ngTemplateOutletContext]="{
        nav_data: nav,
      }"
    ></ng-container>
  }
</ng-template>

<ng-template #navigation_row_item let-nav="nav_data">
  @if (nav.title) {
    <h5 class="navigation-item-title">
      <span>{{ nav.title }}</span>
      @if (nav.hasChildren) {
        <fa-icon [icon]="faChevronRight"></fa-icon>
      }
    </h5>
  } @else {
    <boels-skeleton
      [inputHeight]="36"
      [inputStyle]="{ borderRadius: '4px' }"
    ></boels-skeleton>
  }
</ng-template>
